
import './core/editor-registry';
import './core/editor-input-factory-registry';
import './core/statusbar-registry';
import './core/commands-registry';
import './core/workbench-contribution-registry';
